<template>

  <div class="container admin-table-page">
    <!-- ===== TÍTULO ===== -->
    <div class="param-title-wrap">
      <b-button class="page-back-btn mr-2" variant="link" @click="cierraModal">
        <font-awesome-icon :icon="['fas', 'arrow-alt-circle-left']" />
      </b-button>
      <h2 class="param-title">{{ labels.title }}</h2>
    </div>

    <!-- ===== CONTENEDOR PRINCIPAL (TARJETA BLANCA) ===== -->
    <div class="admin-table-block mt-4">
      <div class="formulario-scroll">
        <b-row class="formulario-row">
          <b-col cols="12">
            <b-form id="create-form" class="formulario-form">
              <b-form-group>
                <!-- =================================================== -->
		<!-- TARJETA 1:                                          -->
                <!-- =================================================== -->
                <div class="formulario-card-section">
                  <div class="formulario-card-header">
			<h3>Contrato {{numContrato}}</h3>
                  </div>
                  <div class="formulario-card-body">
                    <div class="formulario-row-grid" :style="{ '--formulario-columns': 8 }">
                      <div class="formulario-field">
				<text><h5>{{labels.vigencia}}</h5></text> 
                      </div>
                      <div class="formulario-field">
                           <select v-model="vigencia" class="form-control">
                               <option value="">{{ labels.seleccion }}</option> 
                               <option v-for="item in listaFechas" :key="item?.id" :value="item?.vigencia"> {{ item?.vigencia }} </option> 
                           </select>
                       </div>
                      <div class="formulario-field">
                           <b-button style="background-color: #2e507a; width: 35px; height: 35px;" class="md-fab md-primary" @click="adicionUltimaPlantcc()">
                               <i class="fa-solid fa-plus"></i>
                           </b-button>
                      </div>
                      <div class="formulario-field formulario-field-wide-4a4" v-if="showNewVig">
                             <h5>{{labels.newVigencia}}</h5> 
                      </div>
                      <div class="formulario-field" v-else>
                      </div>
                      <div class="formulario-field  formulario-field-wide-6a2" v-if="showNewVig">
                             <input type="month" v-model="newVigencia" class="form-control" >
                      </div>
                      <div class="formulario-field" v-else>
                      </div>
                      <div class="formulario-field" v-if="showNewVig">
			<span>
                             <b-button style="background-color: #d80027; width: 30px; height: 30px;" class="md-fab md-primary" @click="deleteRowFecha()">
                                 <i><font-awesome-icon :icon="['fas', 'trash']" size="xs"/></i>
                             </b-button>
                             <b-button style="background-color: #2e507a; width: 35px; height: 35px;" class="md-fab md-primary" @click="f_newVigencia()">
                                  <i class="fa-solid fa-plus"></i>
                              </b-button>
			</span>
                      </div>
                      <div class="formulario-field" v-else>
                      </div>
                    </div>
                  </div>
                </div>
                <!-- FIN TARJETA 1 -->

                <!-- =================================================== -->
		<!-- TARJETA 2:                                          -->
                <!-- =================================================== -->
		<div class="formulario-card-section">
                  <div class="formulario-card-header">
                    <h4 class="formulario-card-title">{{ labels.centrosCostos }}</h4>
                  </div>
                  <div class="formulario-card-body">
                    <div class="formulario-row-grid" :style="{ '--formulario-columns': 8 }">
                      <div class="formulario-field formulario-field-wide-1a2">
				<b-table
				:items="listContratoCentroCostos"
				:fields="fields"
				hover
				bordered
				responsive

				small
				class="tblEstandar"
				head-variant="custom-blue"


				@row-clicked="(item) => modificarCentro(item.id)" 
				>
					<template #cell(centro_costo_num)="data">
					<div class="text-right">{{ data.item?.centro_costo }}</div> 
					</template>
					<template #cell(centro_costo)="data">
					<div class="text-left">{{ centroCosto(data.item?.centro_costo) }}</div> 
					</template>
				</b-table>
                      </div>
                      <div class="formulario-field">
                           <b-button style="background-color: #2e507a; width: 35px; height: 35px;" class="md-fab md-primary" @click="adicionaCentroCosto()" >
                               <i class="fa-solid fa-plus"></i>
                           </b-button>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- FIN TARJETA 2 -->


              </b-form-group>
            </b-form>
          </b-col>
        </b-row>
      </div>
    </div>

    <!-- MODALES -->

	<AdicionarCentroCosto :modalAdCentroCostos="showAdCentroCostos" :numContrato="numContrato" :vigencia="vigencia" :newVigencia="newVigencia" @reloadTblCntCst="refrescaTblCntCst" @cierraModal="closeModal"></AdicionarCentroCosto>
	<EditarCentroCosto :modEditCentroCostos="showModEditCC" :numContrato="numContrato" :Infocc="detallecc" @reloadTblCntCst="refrescaTblCntCst" @cierraModal="closeModalEdit"></EditarCentroCosto>
	<b-row>
		<b-col class="d-flex justify-content-center" cols="12">
			<b-button class="md-accent" @click="cierraModal">{{ labels.close }}</b-button> 
		</b-col>
	</b-row>
</div>
</template>

<script>
import ContratoCentroCostos from '../../services/ContratoCentroCostos'; 
import AdicionarCentroCosto from './AdicionarCentroCosto.vue'; 
import CentroCostos from '../../services/CentroCostos'; 
import EditarCentroCosto from './EditarCentroCosto.vue'; 

export default {
    name : 'ModificacionCentroCosto',
    props : ['numContrato'],
    components : {
        AdicionarCentroCosto,
        EditarCentroCosto,
    },
    data : () => ({
        listCentroCostos : [],
        listContratoCentroCostos : [],
        activos : [],
        lstTipoActivo : [],
        valAddMejora : '',
        valRetiro : '',
        fgl_adicionar: false,
        showAdCentroCostos: false,
        quitaCentroCosto: false,
        codActivo: null,
        vigencia : '',
        perPage: 500,
        currentPage: 1,
        fields: [
            // { key: 'vigencia', label: 'Vigencia', sortable: false },
            { key: 'centro_costo_num', label: 'Centro costo', sortable: false },
            { key: 'centro_costo', label: 'Descripción', sortable: false },
            { key: 'porcentaje', label: 'Porcentaje', sortable: false },
        ],
        showModEditCC : false,
        detallecc : [],
        listaFechas : [],
        showNewVig : false,
        newVigencia : '',
    }),
    computed:{
        labels(){
            if(this.$store.state._language == "es-ES"){ 
                return {
                    title : 'Centros de Costos',
                    save : 'Guardar',
                    close : 'Cerrar',
                    noRow : "No hay registros",
                    activos : 'Activos',
                    tipoActivo : 'Tipo Activo',
                    proveedor : 'Proveedor',
                    valorCompra : 'Valor Inicial',
                    valorSalvamento : 'Valor salvamento',
                    valorAmortizado : 'Valor amortizado',
                    fechaCompra : 'Fecha compra',
                    valAddMejora : 'Valor adición/mejora',
                    valRetiro : 'Valor retiro',
                    centroCosto: 'Centro Costo',
                    centroCostoD: 'Descripcion',
                    porcentaje: 'Porcentaje',
                    vigencia: 'Vigencia',
                    newVigencia : 'Nueva Vigencia',
                    seleccion : 'Seleccione...' ,
			numeroContrato: "Contrato",
                }            
            }else{
                return {
                    title : 'Costing',
                    save : 'Save',
                    close : 'Close',
                    noRow : "There are not records",
                    activos : 'Assets',
                    tipoActivo : 'Active type',
                    proveedor : 'Provider',
                    valorCompra : 'Purchase value',
                    valorSalvamento : 'Salvage value',
                    valorAmortizado : 'Amortized value',
                    fechaCompra : 'Purchase date',
                    valAddMejora : 'Added value/Improvement',
                    valRetiro : 'Withdrawal value',
                    centroCosto: 'Centro Costo',
                    centroCostoD: 'Descripcion',
                    porcentaje: 'Porcentaje',
                    vigencia: 'Validity',
                    newVigencia : 'New validity',
                    seleccion : 'Select...' 
                }                
            }
        }
    },
    methods:{
        cierraModal(){
            this.$emit('cierraModal',false) 
        },
        saveModActivos(){
            console.log('saveModActivos'); 
        },
        quitarCentro(centroCosto){
            this.centro_costo = centroCosto 
            this.quitaCentroCosto = true 
        },
        cierraModalAdv(){
            this.quitaCentroCosto = false 
        },
        adicionaCentroCosto() {
            this.fgl_adicionar = true 
            this.showAdCentroCostos = true 
        },
        closeModal(val){
            this.showAdCentroCostos = val 
        },
        closeModalEdit(valor){
            this.showModEditCC = valor 
        },
        centroCosto(centroCosto) {
            if	(centroCosto == null || centroCosto == undefined) {
                return ''
            }
            const v_centro = this.listCentroCostos.find((centro) => centro.centro_costo == centroCosto) 
            if	(v_centro == undefined) {
                return "Centro costo "+centroCosto
            }
            return v_centro?.descripcion 
        },
        modificarCentro(cc) {
            // console.log(cc) 
            ContratoCentroCostos.consultaCentroCostoById(cc) 
            .then((res) => { 
                // console.log(res.data); 
                this.detallecc = res.data.infoCentroCosto 
                this.showModEditCC = true 
            })
            .catch((err) => console.log(err)) 
        },
        refrescaTblCntCst(valFecha){
            this.showAdCentroCostos = false 
            this.showModEditCC = false 

            ContratoCentroCostos.leaContratoCentroCostos(this.numContrato) 
            .then((res) => { 
                // console.log(res.data); 
                this.listContratoCentroCostos = res.data.listContratoCentroCostos 
                this.listContratoCentroCostos = this.listContratoCentroCostos.filter((cc) => cc.vigencia == valFecha) 
            })
            .catch((err) => console.log(err)) 
        },
        adicionUltimaPlantcc(){
            this.showNewVig = true 
//            this.vigencia = lastFecha.vigencia //Asigno ultima fecha para cargar plantilla por el watch 
        },
        deleteRowFecha(){
            this.showNewVig = false 
        },
recargaTblcc(){
            this.showNewVig = false 
            this.vigencia = this.newVigencia 
},
f_newVigencia(){
	ContratoCentroCostos.getFechasCentroCostosByContrato(this.numContrato) 
	.then((res) => { 
	// console.log(res.data); 
		this.listaFechas = res.data.lstFechas 
	})
	.catch((err) => console.log(err)) 

        const lastFecha = this.listaFechas[0] 
        if(this.newVigencia <= lastFecha.vigencia){ 
		this.$toast.error(`La vigencia debe ser mayor a ${ lastFecha.vigencia } `)
        }else{
                console.log(this.newVigencia,lastFecha.vigencia); 

                const info = {
                    'numContrato' : this.numContrato, 
                    'oldFecha' : lastFecha.vigencia, 
                    'newFecha' : this.newVigencia,
                    'idUser' : this.$store.state.userId 
                }
                // console.log(info); 

                ContratoCentroCostos.newPlantillaContratoCentroCosto(info) 
                .then((res) => { 
                    // console.log(res.data); 
                    this.$toast.success(res.data.message) 
                    this.recargaTblcc() 
                })
                .catch((err) => console.log(err))
		.finally(() => { 
			this.vigencia=this.newVigencia
			this.listaFechas.push(this.newVigencia)
		})
        }
},
},
mounted(){
        CentroCostos.getAllCentroCostos() 
        .then((res) => { 
            this.listCentroCostos = res.data.listCentroCostos 
        })
        .catch((err) => console.log(err)) 

        // ContratoCentroCostos.leaContratoCentroCostos(this.numContrato) 
        // .then((res) => { 
        // console.log(res.data); 
        // this.listContratoCentroCostos = res.data.listContratoCentroCostos 
        // })
        // .catch((err) => console.log(err)) 
        ContratoCentroCostos.getFechasCentroCostosByContrato(this.numContrato) 
        .then((res) => { 
            // console.log(res.data); 
            this.listaFechas = res.data.lstFechas 
        })
        .catch((err) => console.log(err)) 


    },
    watch:{
        vigencia(valVigencia){
            // console.log(valVigencia,'VIGENCIA'); 
            const lastFecha = this.listaFechas[0] 

            if(valVigencia == ""){
                this.listContratoCentroCostos = [] 
                this.showNewVig = false 
            
            }else if(valVigencia <= lastFecha.vigencia){ 
                

                ContratoCentroCostos.leaContratoCentroCostos(this.numContrato) 
                .then((res) => { 
                    // console.log(res.data); 
                    this.listContratoCentroCostos = res.data.listContratoCentroCostos 
                    this.listContratoCentroCostos = this.listContratoCentroCostos.filter((cc) => cc.vigencia == valVigencia) 
                    this.showNewVig = false 
                })
                .catch((err) => console.log(err)) 
            }
        },
    }
}
</script>
<style src="../formulario.css" > </style>
